import TagManager from 'react-gtm-module';

window.dataLayer = [];

export const startAnalytics = () => {
  TagManager.initialize({
    gtmId: 'GTM-TQKXK3',
  });
};
